<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title">确认购买</div>
                    <div class="pay-view">
                        <p v-if="buff">确认花费<b>{{ cost }}梦三币</b>购买道具吗？</p>
                        <p v-else>您确认花费<b>{{ cost }}梦三币</b>购买道具吗？您当前尚未获取8折券，使用8折券可享受更低折扣！</p>                   
                    </div>
                                      
                    <div class="u-ctrl">
                        <div class="u-btn cancel" v-if="buff" @click="closeModal"></div>
                        <div class="u-btn invite" v-else  @click="call_invite()"></div>   
                        <div class="u-btn ok" @click="apply"></div>                       
                    </div>
                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-view{
    margin: 55px 0 60px;
}

.pay-view p{
    text-align: center;
    line-height: 1.8;
    font-size: 22px;
    color: #666565;
}

.pay-view b{
    color: #ea583f;
}

.warn{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%; 
    margin-top: 15px;
    font-size: 20px;
    color: #c2393f;
    text-align: center;
    vertical-align: text-top;
}

.i-warn{
    display: inline-block;
    width: 17px;
    height: 18px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/icon-warn.png);
    vertical-align: sub;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
}

.u-btn.ok{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-btn.invite{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-go.png);    
}

.u-ctrl .u-btn.cancel{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import {
    apiCartApply,
    apiInviteCode,
    apiShopList,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            id : 1,
            giftName : '----',
            cost : 100,
            num : 1,
            score : 0,
            text : '',
            item : {},
            list : [],
            buff : true,
            friend_list : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        tempDestory(){

        },       
        closeModal(){
            this.destroyElement()
        },
        init_list(){
            apiShopList().then(
                res => {
                    this.$store.commit("$_setList", res.data);
                },
            )
        },        
        call_invite(){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            apiInviteCode({mode : 2}).then(
                res => {
                    this.destroyElement();
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url; 
                    this.$invite_modal({ shareTxt : shareTxt , friend_list : this.friend_list , buff : this.buff});                   
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },              
        apply(){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }
            
            if(this.cost <= 0){
                this.$toast('请先选择商品');
                return;
            }
            
            let goods_list = this.list.map( item => item.id );
            let result = [];

            apiCartApply({ ids : goods_list , amt : this.cost}).then(
                res => {
                    //todo push
                    result = res.data == null ? this.list : this.list.concat([ { ...res.data , flag : 1 }]);
                    this.init_list();
                    this.destroyElement();

                    this.$result_modal({ giftList : result , cost : this.cost , fromType : 1 });
                    

                    // this.$destroy()
                    // this.$el.parentNode.removeChild(this.$el)                    
                },
                rej => {
                    this.$toast(rej.message);
                    this.destroyElement();

                    //this.$result_modal({ giftList : this.list , cost : this.cost });
                 
                }
            )
        },        
    },    
}
</script>